import React, { useState } from "react";
import { useSelector } from "react-redux";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import FeedbackCard from "./FeedbackCard";
import FeedBacksModal from "./FeedBacksModal";
import Carousel from "react-material-ui-carousel";
import { CircularProgress } from "@material-ui/core";

const Feedbacks = ({ loading }) => {
  const language = useSelector((state) => state.store?.language);
  const feedbacks = useSelector((state) => state.feedbacks?.feedbacks);
  const themeColor = useSelector((state) => state.store.store.settings?.dark);

  const [open, setOpen] = React.useState(false);
  const [width, setWidth] = React.useState(0);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div style={{ marginTop: 30 }}>
      {open && (
        <FeedBacksModal
          feedbacks={feedbacks}
          handleOpen={handleOpen}
          handleClose={handleClose}
          open={open}
          width={width}
        />
      )}
      <div
        style={{
          display: "flex",
          justifyContent: language === "arabic" ? "right" : "left",
          flexDirection: language === "arabic" ? "row-reverse" : "row",
        }}
      >
        <p
          className="box-title"
          style={{
            textAlign: language === "arabic" ? "right" : "left",
          }}
        >
          {language === "arabic" ? "آراء العملاء" : "Customer reviews"}
        </p>
        <span
          style={{
            color: themeColor,
            textDecoration: "underline",
            fontWeight: "bold",
          }}
          onClick={handleOpen}
        >
          {language === "arabic" ? "عرض المزيد" : "View more"}
        </span>
      </div>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: 15 }}>
          <CircularProgress style={{ color: themeColor }} />
        </div>
      ) : (
        <Carousel
          autoPlay={false}
          cycleNavigation={false}
          animation={"slide"}
          indicators={true}
          swipe={true}
          navButtonsAlwaysVisible={true}
          NextIcon={<NavigateNextIcon />}
          PrevIcon={<NavigateBeforeIcon />}
          navButtonsProps={{
            style: {
              padding: 5,
              background: themeColor,
              color: "white",
              borderRadius: "50%",
            },
          }}
        >
          {feedbacks.slice(0, 5).map((feedback) => (
            <FeedbackCard
              themeColor={themeColor}
              setWidth={setWidth}
              key={feedback.id}
              feedback={feedback}
              width={width}
            />
          ))}
        </Carousel>
      )}
    </div>
  );
};

export default Feedbacks;
